import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../wishlist.css'
import Individual from './individual'
import Collaboration from './collaboration'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const TABS = [
    { key: 'individual', label: 'Individual' },
    { key: 'collaborations', label: 'Collaborations' },
]

const WishlistPersonal = () => {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('individual')

    return (
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='commonMaxWidth'>
                        <div className='tripDocHeader mb-4' onClick={() => navigate(-1)}>
                            <BackArrow />
                            <span className='bsSectionTitle'>Wishlist</span>
                        </div>
                        <div className='commonBookingTab commonBookingTab--split'>
                            {TABS.map((tab) => (
                                <div
                                    key={tab.key}
                                    className={`bookTab ${activeTab === tab.key ? 'active' : ''}`}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    {tab.label}
                                </div>
                            ))}
                        </div>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <div className='commonMaxWidth'>{activeTab === 'individual' ? <Individual /> : <Collaboration />}</div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WishlistPersonal
